import AttributeValue from "./AttributeValue"

export default class AttributeQuestionValue extends AttributeValue {
    constructor(data) {
        super(data)
    }
}
